export const barsAndSectors = {
	title: "Bares",
	description:
		"Gestiona y personaliza la configuración de inventario, impresora y menú para los bares.",
	barsAndSectors: "Bares y Sectores",
	bars: "Bares",
	sectors: "Sectores",
	generalSettings: "Configuración General",
	printByTableSettings: "Configuración de Entorno y Mesas",
	editSector: "Editar Sector",
	createSector: "Crear Sector",
	createNewSector: "Crear Nuevo Sector",
	newSector: "Nuevo Sector",
	searchPlaceholderSector: "Buscar por nombre de sector o bar",
	searchPlaceholderAccess: "Buscar por nombre de acceso",
	sectorName: "Nombre del Sector",
	sectorBars: "Bares del Sector",
	accessControl: "Control de Acceso",
	createAccess: "Crear Acceso",
	newAccess: "Nuevo Acceso",
	editAccess: "Editar Acceso",
	createNewAccess: "Crear Nuevo Acceso",
	accessName: "Nombre del Acceso",
	initialDate: "Inicio",
	endDate: "Fin",
	range: "Rango de ZigCards",
	zigCardsId: "ID de ZigCard",
	downloadModel: "Descargar el archivo modelo",
	selectFile: "Seleccionar archivo",
	selectFileDescription: "Tipo de archivo [.xlsx, .xls] hasta [500 mb].",
	removeFile: "Eliminar archivo",
	createAccessSuccess: "Acceso creado con éxito",
	editAccessSuccess: "Acceso editado con éxito",
	name: "Nombre",
	initialDateHour: "Fecha y hora inicial",
	endDateHour: "Fecha y hora final",
	deleteSector: "Eliminar sector",
	deleteSectorSubtitle: "¿Estás seguro de que quieres eliminar el sector?",
	deleteSectorSuccess: "Sector eliminado con éxito",
	editSectorSuccess: "Sector editado con éxito",
	createSectorSuccess: "Sector creado con éxito",
	deleteAccessPolicy: "Eliminar acceso",
	deleteAccessPolicySubtitle: "¿Estás seguro de que quieres eliminar el acceso?",
	deleteAccessPolicySuccess: "Acceso eliminado con éxito",
	editAccessPolicySuccess: "Acceso editado con éxito",
	createAccessPolicySuccess: "Acceso creado con éxito",
	importAccessPolicyTagsSuccess: "IDs importados con éxito",
	accesses: "Accesos",
	sectorAccesses: "Accesos del Sector",
	modelFileName: "modelo-planilla",
	noSectors: "No hay sectores registrados",
	tagIdsError: "Añade al menos un ID de ZigCard",
	onlySpacesError: "El campo no puede contener solo espacios",
	seeZigCards: "Ver ZigCards",
};
